import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileMedicalHistoryInfectiousDiseases extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private sectionId = "MedicalHistory_Section7_InfectiousDiseases";
    private medicalHistoryInfectiousDiseasesOther = `${this.sectionId}_Other`;

    public render(): JSX.Element {
        const section7 = this.props.form.Section7;

        return (
            <div className="col-md-12 flex-display section7-subfield padding-xs-top">
                <div className="flex-display nowrap">
                    {this.controlRenderer.renderInlineRadio({
                        value: section7.InfectiousDiseases.HasInfectiousDiseases,
                        items: this.getFalseTrueRadioOptionsWithoutLabel(),
                        onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.InfectiousDiseases.HasInfectiousDiseases = value),
                        id: `${this.sectionId}_HasInfectiousDiseases`,
                        className: "radios-one-label",
                        optionSpacing: "15px"
                    })}
                    <label className="margin-none margin-xs-left" style={{ width: "auto", minWidth: "fit-content" }}>{this.getString("ObstetricalFile_InfectiousDiseasesLabel")}</label>
                </div>
                <div>
                    {this.controlRenderer.renderCheckbox(
                        "VaricellaLabel",
                        section7.InfectiousDiseases.HasVaricella,
                        value => this.mutateInfectiousDiseasesModel(s => s.Section7.InfectiousDiseases.HasVaricella = value, true),
                        "margin-md-left"
                    )}
                    {this.controlRenderer.renderCheckbox(
                        "HerpesSimplexVirusAbbreviationLabel",
                        section7.InfectiousDiseases.HasHerpesSimplexVirus,
                        value => this.mutateInfectiousDiseasesModel(s => s.Section7.InfectiousDiseases.HasHerpesSimplexVirus = value, true),
                        "margin-md-left"
                    )}
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_InfectiousDiseases_Other`,
                        "ObstetricalFile_OtherLabel",
                        section7.InfectiousDiseases.Other.Value,
                        value => {
                            this.mutateInfectiousDiseasesModel(
                                s => s.Section7.InfectiousDiseases.Other.Value = value,
                                true,
                                () => this.setFocusTextbox(value, this.medicalHistoryInfectiousDiseasesOther)
                            );
                        },
                        this.getAdditionalTextBox({
                            id: this.medicalHistoryInfectiousDiseasesOther,
                            value: section7.InfectiousDiseases.Other.Description,
                            onChange: value => this.mutateInfectiousDiseasesModel(s => s.Section7.InfectiousDiseases.Other.setDescriptionAndCheckbox(value)),
                            maxLength: this.page1FieldLimits.MedicalHistory_InfectiousDiseases_OtherDescription.MaxChars,
                            valueClassName: "margin-xs-left"
                        }),
                        true,
                        "margin-md-left"
                    )}
                </div>
            </div>
        );
    }

    private mutateInfectiousDiseasesModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                if (s.Section7.InfectiousDiseases.HasInfectiousDiseases == null)
                    s.Section7.InfectiousDiseases.HasInfectiousDiseases = s.Section7.InfectiousDiseases.hasSelectedAnyMedicalHistoryInfectiousDiseases();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileMedicalHistoryInfectiousDiseases };
